import React from 'react';
import { Box, Grid, Paper } from '@material-ui/core';
import DropCitySwitch from '../DropCitySwitch';
import DropCitySelect from '../DropCitySelect';
import { useIsDesktop } from 'components/utilities';

export const StickyBar = () => {
	const isDesktop = useIsDesktop();

	const desktopBar = (
		<Paper square elevation={2}>
			<Box px={3} py={2}>
				<Grid container spacing={4} justify="space-between" alignItems="center">
					<Grid item xs={6}>
						<DropCitySwitch />
					</Grid>
					<Grid item xs={6}>
						<DropCitySelect />
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);

	const mobileBar = (
		<Box px={3} py={2}>
			<Grid container spacing={2} justify="space-between" alignItems="center">
				<Grid item xs={12}>
					<DropCitySelect />
				</Grid>
				<Grid item xs={12}>
					<DropCitySwitch />
				</Grid>
			</Grid>
		</Box>
	);

	if (isDesktop) {
		return desktopBar;
	} else {
		return mobileBar;
	}
};
